<div class="flex-between-stretch gap-5 max-md:flex-col">
    <div class="flex-1 stats-box">
        <div class="stats-header w-full flex-between-center">
            <div>Trading Volume Analysis</div>
            <span
                nz-icon
                nzType="caret-down"
                class="text-xl cursor-pointer md:hidden"
                [ngClass]="{'rotate-180': volumeAnalysisCollapsed}"
                (click)="volumeAnalysisCollapsed = !volumeAnalysisCollapsed"
            ></span>
        </div>

        <div *ngIf="!volumeAnalysisCollapsed" class="stats-content !pb-0">
            <div class="w-full flex-between-center gap-x-2.5">
                <div class="w-16 md:w-[120px]"></div>
                <div class="flex-1 flex-between-center text-xs md:text-sm font-bold px-2.5">
                    <div class="text-[#4859DB]">Insider</div>
                    <div class="text-[#FBBA13]">Retail</div>
                </div>
            </div>
            <div class="card flex-between-start gap-x-2.5">
                <div class="w-16 max-md:text-[11px] md:w-[120px] max-md:mt-2">Volume (24h)</div>
                <div class="flex-1 flex-between-center gap-x-2 md:gap-x-3">
                    <div class="py-1.5 md:py-2 px-2.5 relative h-[34px] md:h-[43px] flex-1 text-[#4859DB] rounded-md">
                        <img
                            src="/assets/imgs/rounded-right-cut-tag.svg"
                            alt=""
                            class="flex-1 absolute top-0 left-0 w-full h-full object-cover md:object-right-top rounded-l-md"
                        />
                        <div class="relative z-10">
                            <div class="text-base md:text-xl font-semibold">${{ volumeAnalysis?.insider_volume_24h | kmb2:2 }}</div>
                        </div>
                    </div>

                    <div class="max-md:-mx-[16px] relative z-10 text-base md:text-[32px] text-black text-opacity-25">VS.</div>

                    <div class="py-1.5 md:py-2 px-2.5 relative h-[34px] md:h-[43px] flex-1 text-right text-[#FBBA13] rounded-r-md">
                        <img
                            src="/assets/imgs/rounded-left-cut-tag.svg"
                            alt=""
                            class="flex-1 absolute top-0 left-0 w-full h-full object-cover md:object-left-bottom rounded-r-md"
                        />
                        <div class="relative z-10">
                            <div class="text-base md:text-xl font-semibold">${{ volumeAnalysis?.retail_volume_24h | kmb2:2 }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card flex-between-start gap-x-2.5">
                <div class="w-16 max-md:text-[11px] md:w-[120px] mt-1">% of Total Volume</div>
                <div class="flex-1 flex-between-center gap-x-3 md:gap-x-[78px]">
                    <div class="px-2.5 relative h-8 flex-1 text-black font-semibold bg-[#D9D9D973] max-md:rounded-md overflow-hidden">
                        <div
                            class="z-0 absolute left-0 top-0 bg-[#9EAAFF] h-full"
                            [ngStyle]="{
                                width: insiderPercent === 1
                                    ? '100%'
                                    : insiderPercent === 0
                                    ? '0'
                                    : insiderPercent * 100 > 95
                                    ? '95%'
                                    : insiderPercent * 100 < 10
                                    ? '10px'
                                    : insiderPercent * 100 + '%'
                            }"
                        ></div>
                        <div class="w-full relative z-10 h-full text-base md:text-xl !leading-8">{{ insiderPercent | percent:'1.0-2' }}</div>
                    </div>

                    <div class="px-2.5 relative h-8 flex-1 text-black font-semibold bg-[#D9D9D973] max-md:rounded-md overflow-hidden">
                        <div
                            class="z-0 absolute left-0 top-0 bg-[#FFCC49] h-full"
                            [ngStyle]="{
                                width: retailPercent === 1
                                    ? '100%'
                                    : retailPercent === 0
                                    ? '0'
                                    : retailPercent * 100 > 95
                                    ? '95%'
                                    : retailPercent * 100 < 10
                                    ? '10px'
                                    : retailPercent * 100 + '%'
                            }"
                        ></div>
                        <div class="w-full relative z-10 h-full text-base md:text-xl !leading-8">{{ retailPercent | percent:'1.0-2' }}</div>
                    </div>
                </div>
            </div>

            <div class="card hidden md:flex-between-start gap-x-2.5">
                <div class="md:w-[120px]">Net Buy</div>
                <div class="flex-1 flex-between-center gap-x-[78px]">
                    <div class="flex-1 grid grid-cols-3 text-center gap-x-3">
                        <div>
                            <div class="net-buy-text">15 mins</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_15m > 0, 'text-error': volumeAnalysis?.insider_net_volume_15m < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_15m) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">1h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_1h > 0, 'text-error': volumeAnalysis?.insider_net_volume_1h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_1h) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">24h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_24h > 0, 'text-error': volumeAnalysis?.insider_net_volume_24h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_24h) }}
                            </div>
                        </div>
                    </div>

                    <div class="flex-1 grid grid-cols-3 text-center gap-x-3">
                        <div>
                            <div class="net-buy-text">15 mins</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_15m > 0, 'text-error': volumeAnalysis?.retail_net_volume_15m < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_15m) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">1h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_1h > 0, 'text-error': volumeAnalysis?.retail_net_volume_1h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_1h) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">24h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_24h > 0, 'text-error': volumeAnalysis?.retail_net_volume_24h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_24h) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card md:hidden">
                <div class="flex-between-start gap-x-2.5 mb-3">
                    <div class="w-16 max-md:text-[11px]">Insider Net Buy</div>
                    <div class="flex-1 grid grid-cols-3 text-center gap-x-3">
                        <div>
                            <div class="net-buy-text">15 mins</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_15m > 0, 'text-error': volumeAnalysis?.insider_net_volume_15m < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_15m) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">1h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_1h > 0, 'text-error': volumeAnalysis?.insider_net_volume_1h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_1h) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">24h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.insider_net_volume_24h > 0, 'text-error': volumeAnalysis?.insider_net_volume_24h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.insider_net_volume_24h) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-between-start gap-x-2.5">
                    <div class="w-16 max-md:text-[11px]">Retail Net Buy</div>
                    <div class="flex-1 grid grid-cols-3 text-center gap-x-3">
                        <div>
                            <div class="net-buy-text">15 mins</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_15m > 0, 'text-error': volumeAnalysis?.retail_net_volume_15m < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_15m) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">1h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_1h > 0, 'text-error': volumeAnalysis?.retail_net_volume_1h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_1h) }}
                            </div>
                        </div>

                        <div>
                            <div class="net-buy-text">24h</div>
                            <div
                                class="net-buy-num"
                                [ngClass]="{'text-success': volumeAnalysis?.retail_net_volume_24h > 0, 'text-error': volumeAnalysis?.retail_net_volume_24h < 0}"
                            >
                                {{ localFormatNumber(volumeAnalysis?.retail_net_volume_24h) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card !p-0 mt-1">
                <div class="text-sm font-semibold mt-3">Trading Volume Chart</div>

                <div class="relative">
                    <ng-container *ngIf="volumeChartData?.length">
                        <div class="absolute text-2xs top-[37px] -rotate-90 -left-4">Volume</div>
                        <div class="absolute text-2xs bottom-[141px] right-[-100px] -rotate-90">Retail trading volume participation rate %</div>
                    </ng-container>

                    <div class="h-[280px] w-full">
                        <div
                            *ngIf="volumeChartData?.length"
                            class="h-full w-full"
                            appEcharts
                            [initialOption]="volumeChartInitialOption"
                            [optionToBeUpdate]="volumeOptionsToBeUpdate"
                        ></div>

                        <div *ngIf="!volumeOptionsToBeUpdate" class="w-full h-full" appLoading [loading]="true"></div>
                        <div *ngIf="volumeOptionsToBeUpdate && !volumeChartData?.length" class="w-full h-full flex-center-center text-sub-text text-sm">
                            No data
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full md:w-[360px] stats-box">
        <div class="stats-header w-full flex-between-center">
            <div>MEME Info</div>
            <span
                nz-icon
                nzType="caret-down"
                class="text-xl cursor-pointer md:hidden"
                [ngClass]="{'rotate-180': memeInfoCollapsed}"
                (click)="memeInfoCollapsed = !memeInfoCollapsed"
            ></span>
        </div>

        <div *ngIf="!memeInfoCollapsed" class="stats-content !py-0">
            <div class="card">
                <div class="text-center">
                    <div class="flex-start-center w-full">
                        <div class="stats-item-1 rounded-tl-2xl">
                            <div class="label">Liquidity</div>
                            <div class="value">${{ tokenInfo ? (tokenInfo.dex_liquidity | kmb2:2) : '--' }}</div>
                        </div>

                        <div class="stats-item-1 rounded-tr-2xl">
                            <div class="label">MKT Cap</div>
                            <div class="value">${{ tokenInfo ? (tokenInfo.market_cap | kmb2:2) : '--' }}</div>
                        </div>
                    </div>

                    <div class="grid grid-cols-3">
                        <div class="stats-item-1">
                            <div class="label">Price 15m%</div>
                            <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_15m > 0, 'text-error': tokenInfo?.price_change_15m < 0}">
                                {{tokenInfo?.price_change_15m ? (tokenInfo?.price_change_15m | percent:'1.0-2') : '--'}}
                            </div>
                        </div>
                        <div class="stats-item-1">
                            <div class="label">Price 1h%</div>
                            <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_1h > 0, 'text-error': tokenInfo?.price_change_1h < 0}">
                                {{tokenInfo?.price_change_1h ? (tokenInfo?.price_change_1h | percent:'1.0-2') : '--'}}
                            </div>
                        </div>
                        <div class="stats-item-1">
                            <div class="label">Price 1d%</div>
                            <div class="value" [ngClass]="{'text-success': tokenInfo?.price_change_1d > 0, 'text-error': tokenInfo?.price_change_1d < 0}">
                                {{tokenInfo?.price_change_1d ? (tokenInfo?.price_change_1d | percent:'1.0-2') : '--'}}
                            </div>
                        </div>
                    </div>

                    <div class="rounded-b-2xl mt-2.5 h-[70px] relative" appLoading [loading]="trendingChartLoading">
                        <div class="w-full h-full" appEcharts [initialOption]="initialOption" [optionToBeUpdate]="optionsToBeUpdate"></div>

                        <div *ngIf="!optionsToBeUpdate && !trendingChartLoading" class="absolute top-0 left-0 w-full h-full flex-center-center">No data</div>
                    </div>
                </div>
            </div>

            <div class="card space-y-4 !py-4">
                <div class="stats-item-2">
                    <div class="label">Smart Buy</div>
                    <div class="value">
                        <span class="text-success" [nz-tooltip]="tokenInfo?.smart_money_last_trade_block_timestamp | date:'MM/dd HH:mm'">
                            ({{lastSmartBuyAge}})
                        </span>
                        {{(tokenInfo?.smart_money_buy_amount_usd || 0) | kmb2:2}}
                        <span class="text-sub-text font-normal"> | </span>
                        {{tokenInfo?.smart_money_buy_percentage | percent:'1.0-2'}}
                    </div>
                </div>

                <div class="stats-item-2">
                    <div class="label">Smart Money/Holders</div>
                    <div class="value">{{ (tokenInfo?.smart_money_swap_count_1d || 0) |kmb2:2 }}/{{ (tokenInfo?.swap_count_1d || 0) |kmb2:2 }}</div>
                </div>

                <div class="stats-item-2">
                    <div class="label">Smart Money TX (24h)</div>
                    <div class="value">
                        {{(tokenInfo?.smart_money_swap_count_1d || 0) |kmb2:2}}
                        <span class="text-sub-text font-normal">|</span>
                        ${{(tokenInfo?.smart_money_swap_amount_usd_1d || 0)|kmb2:2}}
                    </div>
                </div>

                <div class="stats-item-2">
                    <div class="label">TX (24h)</div>
                    <div class="value">
                        {{(tokenInfo?.swap_count_1d || 0)|kmb2:2:true}}
                        <span class="text-sub-text font-normal">|</span> ${{(tokenInfo?.swap_amount_usd_1d || 0)|kmb2:2}}
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="text-sm mb-2 mt-1 font-semibold">Dev Stats</div>
                <div class="flex-between-center w-full gap-x-5">
                    <div class="text-sm text-sub-text">New MEME issuer</div>
                    <div class="text-sm font-semibold">{{(tokenInfo?.dev_stats?.tokens_deployed_count || 0) | number:'1.0-0'}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
